export const convertToISOWithCurrentTime = (dateString: string) => {
  if (dateString === '') return

  const date = new Date(dateString)
  const now = new Date()

  date.setHours(now.getHours())
  date.setMinutes(now.getMinutes())
  date.setSeconds(now.getSeconds())
  date.setMilliseconds(now.getMilliseconds())

  return date.toISOString()
}
